import "./DesignerCanvas.scss"
import get from "lodash/get"
import React, { Component } from "react"
import PropTypes from "prop-types"
import Rnd from "react-rnd"
import { scaleTo } from "./utils"

export default class DesignerCanvas extends Component {
  static propTypes = {
    // width of view
    width: PropTypes.number.isRequired,
    // source of uploaded image
    image: PropTypes.string,
    // the position and size of image
    design: PropTypes.shape({
      top: PropTypes.number,
      left: PropTypes.number,
      width: PropTypes.number,
      aspect: PropTypes.number,
      // height: PropTypes.number.isRequired,
    }),
    // mockup Object
    mockup: PropTypes.shape({
      dimension: PropTypes.string.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      printarea: PropTypes.shape({
        top: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
      }).isRequired,
      assets: PropTypes.objectOf(
        PropTypes.shape({
          image: PropTypes.string.isRequired,
          background_image: PropTypes.string.isRequired,
          background_color: PropTypes.string.isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
    // active mockup key (title/color name in assets)
    mockupColor: PropTypes.string.isRequired,
  }

  state = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  }

  componentWillMount() {
    if (this.props.design && this.props.design.width) {
      // convert from ratios
      const { top, left, width, aspect } = this.props.design
      const state = {
        top: top * this.printarea.height,
        left: left * this.printarea.width,
        width: width * this.printarea.width,
        height: width / aspect * this.printarea.width,
      }
      this.setState(state, this.handleValidation)
    }
    if (this.props.image) {
      this.handleImage(this.props.image)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, "design.width") && !get(this.props, "design.width")) {
      // convert from ratios
      const { top, left, width, aspect } = nextProps.design
      const state = {
        top: top * this.printarea.height,
        left: left * this.printarea.width,
        width: width * this.printarea.width,
        height: width / aspect * this.printarea.width,
      }
      this.setState(state, this.handleValidation)
    }
    if (nextProps.image !== this.props.image) {
      this.handleImage(nextProps.image)
    }
  }

  handleImage = src => {
    this.img = new Image()
    this.img.src = src
  }

  handleCenter = () => {
    this.setState({ top: this.centered.top, left: this.centered.left })
  }

  handleDrag = (e, d) => {
    this.setState({ top: d.y, left: d.x })
  }

  handleResize = (e, direction, ref, delta, position) => {
    this.setState({
      top: position.y,
      left: position.x,
      width: ref.offsetWidth,
      height: ref.offsetHeight,
    })
  }

  handleScale = size => {
    this.setState(state => ({
      top: state.top + state.width / 2 - size / 2,
      left: state.left + state.width / 2 - size / 2,
      width: size,
      height: this.img.height * size / this.img.width,
    }))
  }

  handleStop = () => {
    // convert to ratios
    this.props.onChange({
      top: this.state.top / this.printarea.height,
      left: this.state.left / this.printarea.width,
      width: this.state.width / this.printarea.width,
      aspect: this.img.width / this.img.height,
    })
    this.handleValidation()
  }

  handleValidation = () => {
    if (this.imageDPI <= 75) {
      this.props.onInvalid()
    } else {
      this.props.onValid()
    }
  }

  get scale() {
    return this.props.width / this.props.mockup.width
  }

  get printarea() {
    return scaleTo(this.props.mockup.printarea, this.scale)
  }

  get centered() {
    const top = this.printarea.height / 2 - this.state.height / 2
    const left = this.printarea.width / 2 - this.state.width / 2
    return { top, left }
  }

  get withinBounds() {
    const { top, left, width, height } = this.state
    return (
      top >= 0 &&
      left >= 0 &&
      left + width <= this.printarea.width &&
      top + height <= this.printarea.height
    )
  }

  get mockupStyle() {
    return this.props.mockup.assets[this.props.mockupColor] || {}
  }

  get imageDPI() {
    const [w] = this.props.mockup.dimension.split("x").map(parseFloat)
    const imgWidthInInches = this.state.width / this.printarea.width * w
    return this.img.width / imgWidthInInches
  }

  get imageQuality() {
    if (this.imageDPI > 120) return "Good 👍"
    if (this.imageDPI > 75) return "Average"
    return "Poor 😡"
  }

  render() {
    const { top, left, width, height } = this.state
    const classnames = [
      "DesignerCanvas",
      this.withinBounds ? "DesignerCanvas-valid" : "DesignerCanvas-invalid",
    ].join(" ")

    console.log("DesignerCanvas", width, height)
    return (
      <div className={classnames}>
        <div className="DesignerCanvas_preview">
          <img
            className="DesignerCanvas_mockup"
            src={this.mockupStyle.image}
            style={{
              width: this.props.width,
              height: this.props.mockup.height * this.scale,
              backgroundColor: this.mockupStyle.background_color,
              backgroundImage: `url(${this.mockupStyle.background_image})`,
            }}
            alt=""
          />
          <div className="DesignerCanvas_printarea" style={this.printarea}>
            {this.props.image && (
              <Rnd
                lockAspectRatio
                resizeHandleClasses={{
                  topLeft: "DesignerCanvas_handle",
                  topRight: "DesignerCanvas_handle",
                  bottomRight: "DesignerCanvas_handle",
                  bottomLeft: "DesignerCanvas_handle",
                }}
                position={{ x: left, y: top }}
                size={{ width, height }}
                onDrag={this.handleDrag}
                onResize={this.handleResize}
                onDragStop={this.handleStop}
                onResizeStop={this.handleStop}>
                <div className="DesignerCanvas_design">
                  <img src={this.props.image} draggable={false} alt="design" />
                </div>
              </Rnd>
            )}
          </div>
        </div>
        {this.img &&
        this.state.width > 0 && (
          <div className="DesignerCanvas_controls">
            <span>
              Current DPI: {Math.round(this.imageDPI)} Quality:{" "}
              {this.imageQuality}
            </span>
            {/* <button onClick={this.handleCenter}>Center</button> */}
            {/* <input
              type="range"
              step={1}
              min={10}
              max={this.img.width * this.scale}
              value={this.state.width}
              onMouseUp={this.handleStop}
              onMouseDown={this.handleStart}
              onChange={e => this.handleScale(e.target.value)}
            /> */}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/products/add/DesignerCanvas.js